import {Actions} from '../../actions';
import {connect} from 'react-redux';
import Overview from "../../components/DiversityPE/Overview";

const mapStateToProps = (state, ownProps) => {
    return {
        analyze: state.analyze,
        company_permission: state.home.companyInformation.company_permission,
        diversitype: state.diversitype,
        home: state.home,
        improve: state.improve,
        ...ownProps
    };
};

export default connect(mapStateToProps, Actions)(Overview);
